import React from 'react';

const Links: React.FC = () => {
	return <>
		<a href="https://www.facebook.com/executivetags/" target="_blank" className="footer9_social-link w-inline-block">
			<div className="footer9_social-icon w-embed">
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
					<path
						d="M12 1.3335H9.99996C9.1159 1.3335 8.26806 1.68469 7.64294 2.30981C7.01782 2.93493 6.66663 3.78277 6.66663 4.66683V6.66683H4.66663V9.3335H6.66663V14.6668H9.33329V9.3335H11.3333L12 6.66683H9.33329V4.66683C9.33329 4.49002 9.40353 4.32045 9.52855 4.19542C9.65358 4.0704 9.82315 4.00016 9.99996 4.00016H12V1.3335Z"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</div>
			<div>Facebook</div>
		</a>
		<a href="https://www.instagram.com/executivetags/" target="_blank" className="footer9_social-link w-inline-block">
			<div className="footer9_social-icon w-embed">
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
					<path
						d="M11.6667 4.3335H11.6734M4.66671 1.3335H11.3334C13.1743 1.3335 14.6667 2.82588 14.6667 4.66683V11.3335C14.6667 13.1744 13.1743 14.6668 11.3334 14.6668H4.66671C2.82576 14.6668 1.33337 13.1744 1.33337 11.3335V4.66683C1.33337 2.82588 2.82576 1.3335 4.66671 1.3335ZM10.6667 7.58016C10.749 8.13499 10.6542 8.70164 10.3959 9.19951C10.1375 9.69737 9.7288 10.1011 9.22779 10.3533C8.72678 10.6055 8.159 10.6932 7.60523 10.6041C7.05146 10.515 6.53988 10.2536 6.14327 9.85694C5.74665 9.46032 5.48519 8.94875 5.39609 8.39497C5.30698 7.8412 5.39475 7.27343 5.64692 6.77241C5.8991 6.2714 6.30283 5.86266 6.8007 5.60432C7.29856 5.34599 7.86521 5.25122 8.42004 5.3335C8.98599 5.41742 9.50994 5.68114 9.9145 6.0857C10.3191 6.49026 10.5828 7.01421 10.6667 7.58016Z"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</div>
			<div>Instagram</div>
		</a>
		<a
			href="https://www.linkedin.com/company/executive-tag-&amp;-title-svcs.-inc."
			className="footer9_social-link w-inline-block">
			<div className="footer9_social-icon w-embed">
				<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
					<path
						d="M10.6667 5.3335C11.7276 5.3335 12.745 5.75492 13.4951 6.50507C14.2453 7.25521 14.6667 8.27263 14.6667 9.3335V14.0002H12V9.3335C12 8.97987 11.8596 8.64074 11.6095 8.39069C11.3595 8.14064 11.0203 8.00016 10.6667 8.00016C10.3131 8.00016 9.97395 8.14064 9.7239 8.39069C9.47385 8.64074 9.33337 8.97987 9.33337 9.3335V14.0002H6.66671V9.3335C6.66671 8.27263 7.08813 7.25521 7.83828 6.50507C8.58842 5.75492 9.60584 5.3335 10.6667 5.3335Z"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M4.00004 6.00016H1.33337V14.0002H4.00004V6.00016Z"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M2.66671 4.00016C3.40309 4.00016 4.00004 3.40321 4.00004 2.66683C4.00004 1.93045 3.40309 1.3335 2.66671 1.3335C1.93033 1.3335 1.33337 1.93045 1.33337 2.66683C1.33337 3.40321 1.93033 4.00016 2.66671 4.00016Z"
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"/>
				</svg>
			</div>
			<div>LinkedIn</div>
		</a>
	</>;
};

export default Links;
